import { Component, OnInit, signal } from "@angular/core";
import { VersionCheckService } from "./core/services/version-check.service";
import { TranslationService } from "./core/http/translation/translation.service";
import { CacheRefreshService } from "./core/services/cache-refresh.service";
import { DiagnosticsService } from "./core/services/diagnostics.service";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    standalone: false
})
export class AppComponent implements OnInit {
  readonly title = signal("recolearn-portal");
  versionUrl = window.location.origin + "/version.json";

  constructor(
    private cacheRefreshService: CacheRefreshService,
    private versionCheckService: VersionCheckService,
    private translationService: TranslationService,
    private diagnostics: DiagnosticsService
  ) {
    this.translationService.setLanguage("en");
    this.stripCacheBustingParam();
  }

  private stripCacheBustingParam(): void {
    if (window.location.search.includes("_v=")) {
      const url = new URL(window.location.href);
      url.searchParams.delete("_v");
      window.history.replaceState(null, "", url.pathname + url.hash);
    }
  }

  ngOnInit(): void {
    this.diagnostics.syncSentryUser();
    this.cacheRefreshService.refreshCachedData();
    this.versionCheckService.initVersionCheck(this.versionUrl);
    // Syncfusion globals (L10n locale + RichTextEditor selection patch) belong in
    // core/syncfusion/, not here, so the Syncfusion bundles stay out of the initial chunk.
  }

  changeLanguage(lang: string): void {
    this.translationService.setLanguage(lang);
  }
}
